import React from "react";

interface TeamLogoProps {
  logoUrl?: string | null;
  teamName: string | null;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: { mobile: 48, desktop: 56 },
  md: { mobile: 64, desktop: 80 },
  lg: { mobile: 72, desktop: 96 },
};

function getInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

const TeamLogo: React.FC<TeamLogoProps> = ({ logoUrl, teamName, size = "md" }) => {
  const dims = sizeMap[size];
  const safeName = teamName ?? "TBD";

  const containerStyle: React.CSSProperties = {
    width: dims.mobile,
    height: dims.mobile,
  };

  return (
    <div
      className="flex items-center justify-center shrink-0"
      style={containerStyle}
    >
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={`${safeName} logo`}
          className="w-full h-full object-contain"
          style={{ maxWidth: "100%", maxHeight: "100%" }}
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = "none";
            const fallback = e.currentTarget.nextElementSibling as HTMLElement | null;
            if (fallback) fallback.style.display = "flex";
          }}
        />
      ) : null}
      <div
        className="rounded-xl bg-gradient-to-br from-emerald-800/60 to-emerald-900/60 border border-emerald-600/30 flex items-center justify-center font-bold text-emerald-200"
        style={{
          width: "100%",
          height: "100%",
          fontSize: size === "lg" ? "1.5rem" : "1.125rem",
          display: logoUrl ? "none" : "flex",
        }}
      >
        {getInitials(safeName)}
      </div>
    </div>
  );
};

export default TeamLogo;
